import React from 'react';
import IconButton from './IconButton';

const RemoveButton = ({ disabled, entity, onClick }) => (
  <IconButton
    className="aridhia-remove-button"
    disabled={disabled}
    icon
    iconName="trash"
    iconOnly
    iconClassName="primary"
    messageId={`actions.remove.${entity}.title`}
    onClick={onClick}
  />
);

export default RemoveButton;
